module.exports = __webpack_public_path__ + "static/media/info-gray.d5683e93.svg";